import * as React from 'react'
import { Link } from 'gatsby'
import resolveLink from 'utils/resolveLink'
import SingleLink from './SingleLink'
import InteractiveDetails from './InteractiveDetails'
import clsx from 'clsx'

export default function Dropdown({ label, link, links }) {
	return (
		<li className="relative <md:w-full <md:text-left">
			<InteractiveDetails
				id={label}
				summary={
					!!link ? (
						<Link className="no-underline" to={resolveLink(link)}>
							{label}
						</Link>
					) : (
						label
					)
				}
				contentClassName="-left-8 md:w-[350px] md:max-w-max md:pt-4"
			>
				<ul
					className={clsx(
						'flex flex-col gap-4 border-line-invert text-left',
						'md:rounded-b-2xl md:bg-suede-black md:p-8 md:shadow-lg',
						'<md:my-4 <md:border-l <md:px-4',
					)}
				>
					{links?.map((child, i) => (
						<li key={i}>
							{!!child.links?.length ? (
								<ul className="flex flex-col gap-4">
									<li>
										<SingleLink {...child.link} />
									</li>
									{child.links.map((grandchild, ii) => (
										<li className="pl-4" key={ii}>
											<Link
												className="uppercase no-underline"
												to={resolveLink(grandchild)}
											>
												{grandchild?.title}
											</Link>
										</li>
									))}
								</ul>
							) : (
								<SingleLink {...child} />
							)}
						</li>
					))}
				</ul>
			</InteractiveDetails>
		</li>
	)
}
